<template>
  <footer
    class="footer"
    :class="{[`footer-${type}`]: type}"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="info">
        <div class="org-title">The Big Curt Charitable Foundation</div>
        <div class="address-1">5002 Irvin Road</div>
        <div class="address-2">Chattanooga, TN 37416</div>
        <div class="ein">EIN: 99-3251169</div>
      </div>
      <!-- <nav>
        <ul>
          <li>
            <a href="/">
              Big Curt
            </a>
          </li>
          <li>
            <a href="#about">
              About Us
            </a>
          </li>
        </ul>
      </nav> -->
      <!-- <div class="copyright">
        &copy; {{ year }}
      </div> -->
    </div>
  </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style>
</style>
